interface QueryParams {
  [key: string]: string;
}

export function getQueryParams() {
  const params = new URLSearchParams(window.location.search);
  const vars: QueryParams = {};
  params.forEach((value, key) => {
    vars[key] = value;
  });
  return vars;
}

export function customTrim(str: string) {
  return str.trim().replace(/\s+/g, " ");
}
